import { PlateStatus } from "../models/process-step";

export const axiom384PropelStatusFilter = [
  { label: "Extraction Completed", value: PlateStatus.EXTRACTION_COMPLETED },
  { label: "Start Aliquotation", value: PlateStatus.ALIQUOTATION_STARTED },
  { label: "Complete Aliquotation", value: PlateStatus.ALIQUOTATION_COMPLETED },
  { label: "WGA Started", value: PlateStatus.WGA_STARTED },
  { label: "WGA Completed", value: PlateStatus.WGA_COMPLETED },
  { label: "Fragmentation Started", value: PlateStatus.FRAGMENTATION_STARTED },
  { label: "Fragmentation Completed", value: PlateStatus.FRAGMENTATION_COMPLETED},
  { label: "Precipitation Started", value: PlateStatus.PRECIPITATION_STARTED },
  { label: "Precipitation Completed", value: PlateStatus.PRECIPITATION_COMPLETED },
  { label: "Resuspending Started", value: PlateStatus.RESUSPENDING_STARTED },
  { label: "Resuspending Completed", value: PlateStatus.RESUSPENDING_COMPLETED},
  { label: "Recombining Started", value: PlateStatus.RECOMBINING_STARTED },
  { label: "Recombining Completed", value: PlateStatus.RECOMBINING_COMPLETED },
  { label: "Denaturation Started", value: PlateStatus.DENATURATION_STARTED },
  { label: "Denaturation Completed", value: PlateStatus.DENATURATION_COMPLETED},
  { label: "Plate Redo", value: PlateStatus.PLATE_REDO},
  { label: "Completly Transferred", value: PlateStatus.COMPLETLY_TRANSFERED},
  { label: "Completed", value: PlateStatus.COMPLETED}
];

export const illuminaExInfiniumStatusFilter = [
  { label: "Stored", value: PlateStatus.STORED },
  { label: "Prepcr Started", value: PlateStatus.START_PREPCR },
  { label: "WGA Completed", value: PlateStatus.WGA_COMPLETED },
  { label: "PGX Completed", value: PlateStatus.PGX_COMPLETED },
  { label: "Prepcr Completed", value: PlateStatus.PREPCR_COMPLETED },
  { label: "Recombining Started", value: PlateStatus.RECOMBINING_STARTED },
  { label: "Recombining Completed", value: PlateStatus.RECOMBINING_COMPLETED },
  { label: "Fragmentation Started", value: PlateStatus.FRAGMENTATION_STARTED },
  { label: "Fragmentation Completed", value: PlateStatus.FRAGMENTATION_COMPLETED},
  { label: "Precipitation Started", value: PlateStatus.PRECIPITATION_STARTED },
  { label: "Precipitation Completed", value: PlateStatus.PRECIPITATION_COMPLETED },
  { label: "Resuspending Started", value: PlateStatus.RESUSPENDING_STARTED },
  { label: "Resuspending Completed", value: PlateStatus.RESUSPENDING_COMPLETED},
  { label: "Denaturation Started", value: PlateStatus.DENATURATION_STARTED },
  { label: "Denaturation Completed", value: PlateStatus.DENATURATION_COMPLETED},
  { label: "Completly Transferred", value: PlateStatus.COMPLETLY_TRANSFERED},
  { label: "Completed", value: PlateStatus.COMPLETED}
];
